/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Album } from '../models/Album';
import type { AlbumPatch } from '../models/AlbumPatch';
import type { AlbumPost } from '../models/AlbumPost';
import type { AlbumUser } from '../models/AlbumUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminAlbumsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param userId
     * @param albumId
     * @returns any Default Response
     * @throws ApiError
     */
    public adminAddUserToAlbum(
        userId: number,
        albumId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/add/{userId}/to/{albumId}',
            path: {
                'userId': userId,
                'albumId': albumId,
            },
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * @param userId
     * @param albumId
     * @returns void
     * @throws ApiError
     */
    public adminRemoveUserFromAlbum(
        userId: number,
        albumId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/remove/{userId}/from/{albumId}',
            path: {
                'userId': userId,
                'albumId': albumId,
            },
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * Returns all albums in the system, and all the albums the user has explicit access to.
     * @param userId
     * @returns any Default Response
     * @throws ApiError
     */
    public adminAlbumList(
        userId: number,
    ): CancelablePromise<{
        userAlbums: Array<Album>;
        albums: Array<Album>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/{userId}/albums',
            path: {
                'userId': userId,
            },
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * Update an instance.
     * @param id The album id.
     * @param requestBody
     * @returns Album Default Response
     * @throws ApiError
     */
    public patchAlbum(
        id: number,
        requestBody: AlbumPatch,
    ): CancelablePromise<Album> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/albums/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Update an instance.
     * @param id The album id.
     * @param requestBody
     * @returns Album Default Response
     * @throws ApiError
     */
    public putAlbum(
        id: number,
        requestBody: AlbumPost,
    ): CancelablePromise<Album> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/admin/albums/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * List all albums in the system with the users who have read permissions.
     * @returns AlbumUser Default Response
     * @throws ApiError
     */
    public getAlbumUsers(): CancelablePromise<Array<AlbumUser>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/albums',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
}
